/**
 * Created by dmitry on 01.04.2025
 */

const Merge3ChestTutorial = function () {
    cleverapps.eventBus.on("unitOpened", (unit) => {
        if (Map2dLocation.currentLocation && Unit.Equals(unit, Merge3ChestTutorial.TARGET_CHEST)) {
            Map2dLocation.currentLocation.needsChestTutorial = true;
        }
    });

    return new TutorialScenario("chest_tutorial", {
        listSteps: Merge3ChestTutorial.listSteps,
        isAvailable: function () {
            return Map2dLocation.currentLocation && Map2dLocation.currentLocation.needsChestTutorial;
        },
        onStart: function () {
            Map2dLocation.currentLocation.needsChestTutorial = false;

            cleverapps.focusManager.setEventNodes([]);
        },
        onFinish: function () {
            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
        }
    });
};

Merge3ChestTutorial.listSteps = function () {
    const steps = [];

    Merge3ChestTutorial.STEPS.forEach((data) => {
        if (data.advice) {
            steps.push(MergeTutorialHelper.createAdviceStep(data.advice));
        }
    });

    return steps;
};

Merge3ChestTutorial.TARGET_CHEST = {
    code: "woodchest",
    stage: 0
};

Merge3ChestTutorial.STEPS = [
    {
        advice: {
            type: Map2d.OPENCHEST,
            person: "worker",
            targets: Merge3ChestTutorial.TARGET_CHEST,
            text: "Merge3ChestTutorial.open_chest"
        }
    }
];
